import {WhitelabelEvent, WhitelabelEventWithPayload} from "../../../../common/ts/events/Events";

interface UserSearchSubmittedEventPayload {
    search: string | undefined,
    host: string,
    searchParams?: URLSearchParams | undefined,
}

export class UserSearchSubmittedEvent implements WhitelabelEventWithPayload<UserSearchSubmittedEventPayload> {
    payload: UserSearchSubmittedEventPayload;
    type: string;
    static readonly TYPE: string = 'user-search-submitted';

    constructor(payload: UserSearchSubmittedEventPayload) {
        this.type = UserSearchSubmittedEvent.TYPE;
        this.payload = payload;
    }
}

export class SearchButtonClickedEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'search-button-clicked';

    constructor() {
        this.type = SearchButtonClickedEvent.TYPE;
    }
}

interface UserSearchRenderedPayload {
    pathname: string,
    selector: string,
    inputName: string,
    text: string,
}

export class UserSearchRenderedEvent implements WhitelabelEventWithPayload<UserSearchRenderedPayload> {
    payload: UserSearchRenderedPayload;
    type: string;
    static readonly TYPE: string = 'user-search-rendered';

    constructor(payload: UserSearchRenderedPayload) {
        this.type = UserSearchRenderedEvent.TYPE;
        this.payload = payload;
    }
}

interface PropertyTypeSelectedPayload {
    name: string,
    value: string,
    formData: { [key: string]: any },
    searchParams: URLSearchParams,
}

export class PropertyTypeSelectedEvent implements WhitelabelEventWithPayload<PropertyTypeSelectedPayload> {
    payload: PropertyTypeSelectedPayload;
    type: string;
    static readonly TYPE: string = 'property-type-selected';

    constructor(payload: PropertyTypeSelectedPayload) {
        this.type = PropertyTypeSelectedEvent.TYPE;
        this.payload = payload;
    }
}

interface OperationTypeSelectedPayload {
    name: string,
    value: string,
    isModalOpen: boolean,
    formData: { [key: string]: any },
    searchParams: URLSearchParams,
}

export class OperationTypeSelectedEvent implements WhitelabelEventWithPayload<OperationTypeSelectedPayload> {
    payload: OperationTypeSelectedPayload;
    type: string;
    static readonly TYPE: string = 'operation-type-selected';

    constructor(payload: OperationTypeSelectedPayload) {
        this.type = OperationTypeSelectedEvent.TYPE;
        this.payload = payload;
    }
}